import React, { useState, useEffect } from "react";
import { Row, Col, Modal, Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css";
import "../Villas/Villas.css";

import brochure from '../../../assets/Villas/residence-brochure.pdf';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay, faDownload } from '@fortawesome/free-solid-svg-icons';

// Import local images
import AmbassadorCottageA from "../../../assets/Villas/AmbassadorCottageA.webp";
import AmbassadorCottageB from "../../../assets/Villas/AmbassadorCottageB.webp";
import GovernorSuiteA from "../../../assets/Villas/GovernorSuiteA.webp";
import GovernorSuiteB from "../../../assets/Villas/GovernorSuiteB.webp";
import PresidentialSuitC from "../../../assets/Villas/PresidentialSuiteC.webp";
import AmbassadorStudeoA from "../../../assets/Villas/AmbassadorStudeoA.webp";

// Images for residential
import AmbassadorCottageA1 from "../../../assets/Villas/cottageA/cottageA2.webp";
import AmbassadorCottageA2 from "../../../assets/Villas/cottageA/cottageA3.webp";
import AmbassadorCottageB1 from "../../../assets/Villas/cottageB/cottageB1.webp";
import AmbassadorCottageB2 from "../../../assets/Villas/cottageB/cottageB2.webp";
import GovernorSuiteA1 from "../../../assets/Villas/suiteA/suiteA1.webp";
import GovernorSuiteA2 from "../../../assets/Villas/suiteA/suiteA2.webp";
import GovernorSuiteB1 from "../../../assets/Villas/suiteB/suiteB1.webp";
import GovernorSuiteB2 from "../../../assets/Villas/suiteB/suiteB2.webp";
import PresidentialSuitC1 from "../../../assets/Villas/suiteC/suiteC1.webp";
import PresidentialSuitC2 from "../../../assets/Villas/suiteC/suiteC2.webp";
import AmbassadorStudeoA1 from "../../../assets/Villas/studioA/studioA1.webp";
import AmbassadorStudeoA2 from "../../../assets/Villas/studioA/studioA2.webp";
import api from "../../../config/axiosConfig";

const Villas = () => {
  const [residences, setResidences] = useState([]);
  const [selectedResidence, setSelectedResidence] = useState(null);
  const [mainImages, setMainImages] = useState({});

  const roomImages = [
    {
      id: 1,
      name: "Ambassador Cottage A",
      image: AmbassadorCottageA,
      images: [AmbassadorCottageA1, AmbassadorCottageA2],
    },
    {
      id: 2,
      name: "Ambassador Cottage B",
      image: AmbassadorCottageB,
      images: [AmbassadorCottageB1, AmbassadorCottageB2],
    },
    {
      id: 3,
      name: "Governor Suite A",
      image: GovernorSuiteA,
      images: [GovernorSuiteA1, GovernorSuiteA2],
    },
    {
      id: 4,
      name: "Governor Suite B",
      image: GovernorSuiteB,
      images: [GovernorSuiteB1, GovernorSuiteB2],
    },
    {
      id: 5,
      name: "Presidential Suite C",
      image: PresidentialSuitC,
      images: [PresidentialSuitC1, PresidentialSuitC2],
    },
    {
      id: 6,
      name: "Ambassador Studio",
      image: AmbassadorStudeoA,
      images: [AmbassadorStudeoA1, AmbassadorStudeoA2],
    },
  ];

  useEffect(() => {
    const fetchResidences = async () => {
      try {
        const response = await api.get("/residential");
  
        const fetchedResidences = response.data.map((item) => {
          const roomImage = roomImages.find((room) => room.name === item.name);
          return {
            id: item.id,
            name: item.name,
            description: item.description,
            bedrooms: item.bedrooms,
            bathrooms: item.bathrooms,
            livingrooms: item.livingrooms,
            standardOccupancy: item.standardOccupancy,
            image: roomImage?.image || "", // Use local image if available
            images: roomImage?.images || [], // Use local thumbnails if available
          };
        });
  
        setResidences(fetchedResidences);
      } catch (error) {
        console.error("Error fetching residences:", error);
        setResidences(
          roomImages.map((room) => ({
            id: room.id,
            name: room.name,
            image: room.image,
            images: room.images,
          }))
        ); // Fallback to local data
      }
    };
  
    fetchResidences();
  }, []);
  

  const handleThumbnailClick = (residenceId, image) => {
    setMainImages((prev) => ({
      ...prev,
      [residenceId]: image,
    }));
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = brochure;
    link.download = "Belantara-Residences-brochure.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <section id="Villas" className="px-md-5 px-3">
        <div className="container-fluid residential-div px-md-5 px-3">
          <h3 className="section-heading pb-4 text-center">Oceanfront Residences</h3>

          <div
            className="herodownloadBtndiv d-flex gap-2 align-items-center justify-content-center pb-4 flex-wrap"
            onClick={handleDownload}
          >
            <FontAwesomeIcon icon={faDownload} size="2x" style={{ color: "#e6be80" }} />
            <h6 className="text-white mb-0 text-center">Luxurious Accomodations
            Occupancy Configuration Options</h6>
          </div>

          <Row>
            {residences.map((residence) => (
              <Col lg={4} md={6} key={residence.id} className="mb-4">
                <div
                  className="residential-box"
                  onClick={() => setSelectedResidence(residence)}
                >
                  <div className="imagebox">
                    <img src={residence.image} alt={residence.name} />
                  </div>
                  <div className="descriptionbox p-3">
                    <h3 className="text-center pb-3">{residence.name}</h3>
                    <p className="text-center seemorebtn">See more</p>
                  </div>
                </div>
              </Col>
            ))}
          </Row>
        </div>
      </section>

      {selectedResidence && (
        <Modal
          className="modal-box"
          show={!!selectedResidence}
          onHide={() => setSelectedResidence(null)}
          size="lg"
          centered
        >
          <Modal.Header className="modal-title">
            <Modal.Title>{selectedResidence.name}</Modal.Title>
            <span variant="transparent" onClick={() => setSelectedResidence(null)} style={{ cursor: "pointer" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="7"
                height="7"
                fill="currentColor"
                className="bi bi-x-lg"
                viewBox="0 0 26 26"
              >
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
              </svg>
            </span>
          </Modal.Header>
          <Modal.Body className="modal-body">
            <Row>
              <Col md={6} className="modal-photo mb-3">
                <img
                  src={mainImages[selectedResidence.id] || selectedResidence.image}
                  alt={selectedResidence.name}
                  className="Residences-photo"
                />
              </Col>
              <Col md={6}>
                <p>{selectedResidence.description}</p>
                <Row className="">
                   <Col sm={6}>
                   <p className="text-start text-white">Bedrooms: {selectedResidence.bedrooms}</p>
                   </Col>
                   <Col sm={6}>
                   <p className="text-start text-white">Bathrooms: {selectedResidence.bathrooms}</p>
                   </Col>
                   <Col sm={6}>
                   <p className="text-start text-white">Livingrooms: {selectedResidence.livingrooms}</p>
                   </Col>
                   <Col sm={6}>
                   <p className="text-start text-white">Standard Occupancy: {selectedResidence.standardOccupancy}</p>
                   </Col>
                  </Row>
                <div className="thumbnail-container pt-3 d-flex flex-wrap">
                  {selectedResidence?.images?.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`Thumbnail ${index + 1}`}
                      className={`thumbnail-image me-2 mb-2 ${
                        mainImages[selectedResidence.id] === image ? "active" : ""
                      }`}
                      style={{
                        width: "60px",
                        height: "60px",
                        cursor: "pointer",
                        border:
                          mainImages[selectedResidence.id] === image
                            ? "2px solid #007bff"
                            : "1px solid #ccc",
                      }}
                      onClick={() =>
                        handleThumbnailClick(selectedResidence.id, image)
                      }
                    />
                  ))}
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default Villas;
